export function mergeObj(obj1, obj2) {
    var res = {};
    Object.keys(obj1).forEach(function (item) {
        res[item] = obj1[item];
    });
    Object.keys(obj2).forEach(function (item) {
        res[item] = obj2[item];
    });
    return res;
}
